import { Table } from "@components/Table";
import { Button, LoadingSkeleton } from "@narmi/design_system";
import { useEffect, useState } from "react";
import { $staffApi } from "../../api.ts";
import AddUserScreen from "./AddUserScreen.tsx";
import DeleteUserScreen from "./DeleteUserScreen.tsx";
import UpdateUserScreen from "./UpdateUserScreen.tsx";
import { useNotificationContext } from "cerulean/src/NotificationContext/NotificationContext.tsx";

const ReportsTable = () => {
  const { sendNotification } = useNotificationContext();
  const { data, isLoading, error } = $staffApi.useQuery(
    "get",
    "/api/reports/sisense/team-management/"
  );

  const [adding_user, setAddingUser] = useState(false);
  const [deleting_user, setDeletingUser] = useState(false);
  const [updating_user, setUpdatingUser] = useState(false);
  const [user_to_delete_id, setUserToDeleteId] = useState("");
  const [user_to_delete_email, setUserToDeleteEmail] = useState("");
  const [user_to_update_id, setUserToUpdateId] = useState("");
  const [user_to_update_email, setUserToUpdateEmail] = useState("");

  useEffect(() => {
    if (error) {
      sendNotification({
        type: "negative",
        text: "Failed to load Sisense team management.",
      });
    }
  }, [error, sendNotification]);

  if (isLoading) {
    return <LoadingSkeleton isLoading />;
  }

  if (!data?.team_management_context) {
    return null;
  }

  const team_management_context = data.team_management_context;

  if (adding_user) {
    return (
      <AddUserScreen
        backFunction={() => setAddingUser(false)}
        csrf_token={team_management_context.csrf_token}
        create_user_eligible_roles={team_management_context.create_user_eligible_roles}
      />
    );
  }
  if (deleting_user) {
    return (
      <DeleteUserScreen
        backFunction={() => setDeletingUser(false)}
        csrf_token={team_management_context.csrf_token}
        user_to_delete_id={user_to_delete_id}
        user_to_delete_email={user_to_delete_email}
      />
    );
  }
  if (updating_user) {
    return (
      <UpdateUserScreen
        backFunction={() => setUpdatingUser(false)}
        csrf_token={team_management_context.csrf_token}
        create_user_eligible_roles={team_management_context.create_user_eligible_roles}
        user_to_update_id={user_to_update_id}
        user_to_update_email={user_to_update_email}
      />
    );
  }
  return (
    <>
      <Table>
        <Table.ColGroup>
          <Table.Col width="30%" />
          <Table.Col width="30%" />
          <Table.Col width="30%" />
          <Table.Col width="10%" />
        </Table.ColGroup>
        <Table.Header>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell>Email</Table.HeaderCell>
          <Table.HeaderCell>Analytics role</Table.HeaderCell>
          <Table.HeaderCell>Actions</Table.HeaderCell>
        </Table.Header>
        <Table.Body>
          {team_management_context.sisense_users.map((user) => (
            <Table.Row key={user._id}>
              <Table.Cell>
                {user.firstName} {user.lastName}
              </Table.Cell>
              <Table.Cell>{user.email}</Table.Cell>
              <Table.Cell>{user.sisense_role_narmi_name}</Table.Cell>
              <Table.Cell>
                {user.sisense_role_narmi_name !== "Analytics Admin" && (
                  <>
                    <Button
                      label="Edit"
                      style={{ marginRight: "15px" }}
                      onClick={() => {
                        setUpdatingUser(true);
                        setUserToUpdateId(user._id);
                        setUserToUpdateEmail(user.email);
                      }}
                      kind="plain"
                    />
                    <Button
                      label="Delete"
                      onClick={() => {
                        setDeletingUser(true);
                        setUserToDeleteId(user._id);
                        setUserToDeleteEmail(user.email);
                      }}
                      kind="plain"
                    />
                  </>
                )}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      <p>{team_management_context.remaining_licenses_sentence}</p>
      <Button label="Add user" onClick={() => setAddingUser(true)} />
    </>
  );
};

export default ReportsTable;
